import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import _ from 'underscore';
import { mergeClasses } from '@fluentui/react-components';
import { PanelImageGrid, FolderAssetType, CSMLAssetSource } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';
import { useBackgroundRemovalModalStyle } from './background-removal-modal-style';


export const BackgroundRemovalLibraryGrid = ({
  i18n, dataService, notificationApi, onSelectedImageChange, contentRef,
}) => {
  const [isPageInited, setPageInited] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const selectedImageIdRef = useRef([]);
  const classes = useBackgroundRemovalModalStyle();
  const {
    assets,
    loadData,
    loadMoreData,
  } = dataService;

  const validAssets = useMemo(() => (_.filter(assets, item => (item.sourceType !== CSMLAssetSource.Shutterstock))), [assets]);

  const onSelectImage = useCallback((imageId) => {
    if (imageId === selectedImageIdRef.current) {
      selectedImageIdRef.current = null;
      onSelectedImageChange(null);
    } else {
      const selectedImageitem = validAssets.find(item => item.id === imageId);
      selectedImageIdRef.current = imageId;
      onSelectedImageChange(selectedImageitem);
    }
  }, [validAssets, onSelectedImageChange]);

  const onFailedToLoadData = useCallback(() => {
    notificationApi.showWarning(i18n.getString(_TL_('Failed to load images. Please refresh the page and try again.')));
  }, [i18n, notificationApi]);

  const loadMoreDataWithLoading = useCallback((props) => {
    setLoadingData(true);
    loadMoreData(props).finally(() => {
      setLoadingData(false);
    });
  }, [loadMoreData]);

  // init page
  useEffect(() => {
    if (!isPageInited) {
      setPageInited(true);
    }
  }, [isPageInited]);

  // load data for initial page load
  useEffect(() => {
    if (!isPageInited) {
      // wait until page is initialized
      return;
    }
    setLoadingData(true);
    loadData({
      assetTypeFilter: FolderAssetType.Image,
      isGlobalSearch: true,
      searchText: '',
      sortBy: null,
    })
      .catch(() => {
        onFailedToLoadData();
      }).finally(() => {
        setLoadingData(false);
      });
  }, [isPageInited, loadData, onFailedToLoadData]);

  const isPageLoading = !isPageInited || loadingData;

  return (
    <div className={mergeClasses('grid-container', classes.gridContainer)}>
      <div className={classes.gridTitle}>{i18n.getString(_TL_('Library'))}</div>
      <PanelImageGrid
        isLoadingMore={isPageLoading}
        i18n={i18n}
        onSelectImage={onSelectImage}
        dataService={{
          ...dataService,
          assets: validAssets,
          loadMoreData: loadMoreDataWithLoading,
        }}
        imageWidth={132}
        columnPadding={7}
        isHideDescription
        isMultiple={false}
        overlayBodyRef={contentRef}
      />
    </div>
  );
};
